module.exports = __webpack_public_path__ + "static/fonts/Oxanium-Regular.abe9c991.ttf";